import Raven from 'raven-js';
const identity = stuff => stuff;
export default function createMiddleware(options = {}) {
  /*
    Function that generates a crash reporter for Sentry.
    cfg - object to configure Raven.
    options - customize extra data sent to sentry
      actionTransformer - tranform the action object to send; default to identity function
      logger - the logger to use for logging; default to console.error
  */
  return () => next => action => {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'actionTransformer' does not exist on typ... Remove this comment to see the full error message
      actionTransformer = identity,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'logger' does not exist on type '{}'.
      logger = console.error.bind(console, '[redux-raven-middleware] Reporting error to Sentry:')
    } = options;
    const {
      type,
      payload
    } = action;
    // Do not report sentries for XHRs unless it's a 400
    if (type.indexOf('_FAILURE') !== -1 && payload && payload.error && (!payload.error.xhr || payload.error.status === 400)) {
      Raven.captureException(payload.error, {
        extra: {
          actionType: type
        }
      });
    }
    try {
      Raven.captureBreadcrumb({
        category: 'redux',
        message: action.type
      });
      return next(action);
    } catch (err) {
      logger(err);

      // Send the report.
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      Raven.captureException(err, {
        extra: {
          action: actionTransformer(action)
        }
      });
    }
    return null;
  };
}